import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-blank-page',
  templateUrl: './blank-page.component.html',
  styleUrls: ['./blank-page.component.scss'],
})
export class BlankPageComponent {
  @Input() pageType?: string;
}
